import {Button, Col, Container, FloatingLabel, Form, Row} from "react-bootstrap";
import {getPathAfterLogin, getUserEmail, isEmailVerified, login} from "../api/UserApi";
import {useLocation, useNavigate} from "react-router";
import React, {useContext, useEffect, useState} from "react";
import {UsacmContext} from "../App";
import {fieldHasErrors, getErrorMessageForField} from "../utils/formUtils";
import {PageHeader} from "../menu/PageHeader";
import {getConfLabel} from "../utils/usacmUtils";
import {CONF_LABEL_KEY_LOGIN_HELP_CONTENT} from "../constants";
import {setReturnPath} from "../utils/networkUtils";


/**
 * The login, shown in place of a page a logged out user tried to reach (eg. a link to a course from outside the site).
 * The page is remembered, and they are taken to it once they have logged in - or created an account and verified it.
 * @param message shown above the login, to say why they are being asked to log in
 */
export function LoginThenReturn({message}) {
  const location = useLocation();

  useEffect(() => {
    setReturnPath(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return <Login message={message}/>;
}

/**
 * @param message optional text shown above the login form
 */
export function Login({message}) {
  const navigate = useNavigate();
  const [usernameEmail, setUsernameEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const {loggedIn, verified} = useContext(UsacmContext);
  const [userLoggedIn, setUserLoggedIn] = loggedIn;
  const [, setEmailVerified] = verified;
  const context = useContext(UsacmContext);
  const [conf,] = context.conference;
  const loginHelpHtml = getConfLabel(conf, CONF_LABEL_KEY_LOGIN_HELP_CONTENT)


  function callLogin(event) {
    event.preventDefault();
    login(usernameEmail, password, (status, data, newErrors) => {
      if (status === 200) {
        setUserLoggedIn(true);
        setEmailVerified(isEmailVerified());
        navigate(getPathAfterLogin());
      } else {
        setErrors(newErrors);
      }
    });
  }

  return (
      <div>
        <PageHeader pageTitle="Login"/>
        <form onSubmit={callLogin}>
          <Container fluid className="usacm-container-narrow">

            {message &&
            <Row>
              <Col className="mb-3 text-center fw-semibold">{message}</Col>
            </Row>
            }

            {loginHelpHtml &&
            <Row>
              <Col className="mb-3">
                <div className="" dangerouslySetInnerHTML={{__html: loginHelpHtml}}/>
              </Col>
            </Row>
            }

            <Row>
              <Col className="mb-3">
                <FloatingLabel
                    controlId="username"
                    label="Username / Email"
                >
                  <Form.Control
                      type="text"
                      name="username"
                      placeholder="username / email"
                      required
                      value={usernameEmail}
                      onChange={e => setUsernameEmail(e.target.value)}/>
                </FloatingLabel>
              </Col>
            </Row>

            <Row>
              <Col className="mb-3">
                <FloatingLabel controlId="password" label="Password">
                  <Form.Control type="password"
                                placeholder="Password"
                                name="password"
                                required
                                value={password}
                                onChange={e => setPassword(e.target.value)}/>
                </FloatingLabel>
              </Col>
            </Row>

            {fieldHasErrors(errors, '') &&
            <Row>
              <Col className="text-center mb-3 usacm-error-message">
                {getErrorMessageForField(errors, '')}
              </Col>
            </Row>
            }

            <Row>
              <Col className="text-center mt-2 mb-3">
                <Button type="submit">Login</Button>
              </Col>
            </Row>

            <Row>
              <Col className="text-center mt-5 mb-3">
                Forgot your password?
                <Button className="btn btn-link" onClick={() => navigate("/forgot-password-send")}>Reset Password</Button>
              </Col>
            </Row>

            <Row>
              <Col className="text-center mb-3">
                Don't have an account yet?
                <Button className="btn btn-link" onClick={() => navigate("/create-account")}>Create Account</Button>
              </Col>
            </Row>

            {userLoggedIn &&
            <Row>
              <Col>
                You are already logged in as {getUserEmail()}
              </Col>
            </Row>
            }
          </Container>
        </form>
      </div>
  );
}
